import { useQuery, useMutation } from 'react-query'
import axios from 'axios'
import { serializeQuery } from './utils'

const ENDPOINT = 'api/point'
const QUERY_KEY = 'point'

export const useGetPointDetails = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'all', query],
    async () => (await axios.get(serializeQuery(`${ENDPOINT}`, query))).data,
    config
  )

export const useGetNexenPoints = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'nex', query],
    async () => (await axios.get(serializeQuery(`${ENDPOINT}/nex`, query))).data,
    config
  )

export const useGetNexenTripPoints = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'nex-trip', query],
    async () => (await axios.get(serializeQuery(`${ENDPOINT}/nex-trip`, query))).data,
    config
  )

export const useGetTripPoints = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'trip', query],
    async () => (await axios.get(serializeQuery(`${ENDPOINT}/trip`, query))).data,
    config
  )

export const useGetTripOrderHistory = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'trip-order-history', query],
    async () => (await axios.get(serializeQuery(`${ENDPOINT}/trip-order-history`, query))).data,
    config
  )

export const useGetSalesIds = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'sales', query],
    async () => (await axios.get(`${serializeQuery(`${ENDPOINT}/sales`, query)}`)).data,
    config
  )

export const useExportTlpPoint = (config = {}) =>
  useMutation(
    (query) =>
      axios.get(`${serializeQuery(`${ENDPOINT}/export-tlp-point`, query)}`, {
        responseType: 'blob',
      }),
    config
  )

export const useExportTripPoint = (config = {}) =>
  useMutation(
    (query) =>
      axios.get(`${serializeQuery(`${ENDPOINT}/export-trip-point`, query)}`, {
        responseType: 'blob',
      }),
    config
  )

export const useExportNexPoint = (config = {}) =>
  useMutation(
    (query) =>
      axios.get(`${serializeQuery(`${ENDPOINT}/export-nex-point`, query)}`, {
        responseType: 'blob',
      }),
    config
  )

export const useExportNexTripPoint = (config = {}) =>
  useMutation(
    (query) =>
      axios.get(`${serializeQuery(`${ENDPOINT}/export-nex-trip-point`, query)}`, {
        responseType: 'blob',
      }),
    config
  )

export const useGetTyrehubPoints = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'tyrehub', query],
    async () => (await axios.get(serializeQuery(`${ENDPOINT}/tyrehub-points`, query))).data,
    config
  )

export const useGetTyrehubPoint = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'tyrehub-detail', query],
    async () => (await axios.get(serializeQuery(`${ENDPOINT}/tyrehub-point`, query))).data,
    config
  )

export const useExportTyrehubPoint = (config = {}) =>
  useMutation(
    (query) =>
      axios.get(`${serializeQuery(`${ENDPOINT}/export-tyrehub-point`, query)}`, {
        responseType: 'blob',
      }),
    config
  )

export const useGetBatteryIncentivePoints = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'battery-incentive', query],
    async () =>
      (await axios.get(serializeQuery(`${ENDPOINT}/battery-incentive-points`, query))).data,
    config
  )

export const useGetBatteryIncentivePoint = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'battery-incentive-detail', query],
    async () =>
      (await axios.get(serializeQuery(`${ENDPOINT}/battery-incentive-point`, query))).data,
    config
  )

export const useExportBatteryIncentivePoint = (config = {}) =>
  useMutation(
    (query) =>
      axios.get(`${serializeQuery(`${ENDPOINT}/export-battery-incentive-point`, query)}`, {
        responseType: 'blob',
      }),
    config
  )

export const useGetMobilNorthChinaTripPoints = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'mobil-north-china-trip', query],
    async () =>
      (await axios.get(serializeQuery(`${ENDPOINT}/mobil-north-china-trip-points`, query))).data,
    config
  )

export const useGetMobilNorthChinaTripPoint = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'mobil-north-china-trip-detail', query],
    async () =>
      (await axios.get(serializeQuery(`${ENDPOINT}/mobil-north-china-trip-point`, query))).data,
    config
  )

export const useExportMobilNorthChinaTripPoint = (config = {}) =>
  useMutation(
    (query) =>
      axios.get(`${serializeQuery(`${ENDPOINT}/export-mobil-north-china-trip-point`, query)}`, {
        responseType: 'blob',
      }),
    config
  )

export const useGetHTL2026Points = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'htl-2026', query],
    async () => (await axios.get(serializeQuery(`${ENDPOINT}/htl-2026-points`, query))).data,
    config
  )

export const useGetHTL2026Point = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'htl-2026-detail', query],
    async () => (await axios.get(serializeQuery(`${ENDPOINT}/htl-2026-point`, query))).data,
    config
  )

export const useExportHTL2026Point = (config = {}) =>
  useMutation(
    (query) =>
      axios.get(`${serializeQuery(`${ENDPOINT}/export-htl-2026-point`, query)}`, {
        responseType: 'blob',
      }),
    config
  )

export const useGetFiestaPoints = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'fiesta', query],
    async () => (await axios.get(serializeQuery(`${ENDPOINT}/fiesta-points`, query))).data,
    config
  )

export const useExportFiestaPoint = (config = {}) =>
  useMutation(
    (query) =>
      axios.get(`${serializeQuery(`${ENDPOINT}/export-fiesta-point`, query)}`, {
        responseType: 'blob',
      }),
    config
  )

export const useGetFiestaTickets = () =>
  useQuery(
    [`${QUERY_KEY}_fiesta_lucky_draw_tikcet`, 'list'],
    async () => (await axios.get(`${ENDPOINT}/fiesta-tickets`)).data,
    { staleTime: 1000 * 60 * 24 }
  )

export const useExportFiestaTicket = (config = {}) =>
  useMutation(
    (query) =>
      axios.get(`${serializeQuery(`${ENDPOINT}/export-fiesta-ticket`, query)}`, {
        responseType: 'blob',
      }),
    config
  )

export const useGetTLPPoints = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'tlp', query],
    async () => (await axios.get(serializeQuery(`${ENDPOINT}/tlp-points`, query))).data,
    config
  )

export const useGetTLPPoint = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'tlp-detail', query],
    async () => (await axios.get(serializeQuery(`${ENDPOINT}/tlp-point`, query))).data,
    config
  )

export const useExportTLPPoints = (config = {}) =>
  useMutation(
    (query) =>
      axios.get(`${serializeQuery(`${ENDPOINT}/export-tlp-points`, query)}`, {
        responseType: 'blob',
      }),
    config
  )

export const useExportTLPPoint = (config = {}) =>
  useMutation(
    (query) =>
      axios.get(`${serializeQuery(`${ENDPOINT}/export-tlp-point`, query)}`, {
        responseType: 'blob',
      }),
    config
  )

export const useGetHTGIncentivePoints = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'htg-incentive-points', query],
    async () => (await axios.get(serializeQuery(`${ENDPOINT}/htg-incentive-points`, query))).data,
    config
  )

export const useGetHTGIncentiveTypes = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'htg-incentive-types', query],
    async () => (await axios.get(serializeQuery(`${ENDPOINT}/htg-incentive-types`, query))).data,
    config
  )

export const useGetHTGIncentivePoint = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'htg-incentive-point', query],
    async () => (await axios.get(serializeQuery(`${ENDPOINT}/htg-incentive-point`, query))).data,
    config
  )

export const useExportHTGIncentivePoint = (config = {}) =>
  useMutation(
    (query) =>
      axios.get(`${serializeQuery(`${ENDPOINT}/export-htg-incentive-point`, query)}`, {
        responseType: 'blob',
      }),
    config
  )
